import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import './links.css';
import * as nls from '../../../nls.js';
import * as async from '../../../base/common/async.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { MarkdownString } from '../../../base/common/htmlContent.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import * as platform from '../../../base/common/platform.js';
import { EditorAction, registerEditorAction, registerEditorContribution } from '../../browser/editorExtensions.js';
import { ModelDecorationOptions } from '../../common/model/textModel.js';
import { LinkProviderRegistry } from '../../common/modes.js';
import { ClickLinkGesture } from '../gotoSymbol/link/clickLinkGesture.js';
import { getLinks } from './getLinks.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IOpenerService } from '../../../platform/opener/common/opener.js';
import { editorActiveLinkForeground } from '../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
import { URI } from '../../../base/common/uri.js';
import { Schemas } from '../../../base/common/network.js';
import * as resources from '../../../base/common/resources.js';
import * as strings from '../../../base/common/strings.js';

function getHoverMessage(link, useMetaKey) {
  var executeCmd = link.url && /^command:/i.test(link.url.toString());
  var label = link.tooltip ? link.tooltip : executeCmd ? nls.localize('links.navigate.executeCmd', 'Execute command') : nls.localize('links.navigate.follow', 'Follow link');
  var kb = useMetaKey ? platform.isMacintosh ? nls.localize('links.navigate.kb.meta.mac', "cmd + click") : nls.localize('links.navigate.kb.meta', "ctrl + click") : platform.isMacintosh ? nls.localize('links.navigate.kb.alt.mac', "option + click") : nls.localize('links.navigate.kb.alt', "alt + click");

  if (link.url) {
    var hoverMessage = new MarkdownString('', true).appendMarkdown("[".concat(label, "](").concat(link.url.toString(), ") (").concat(kb, ")"));
    return hoverMessage;
  } else {
    return new MarkdownString().appendText("".concat(label, " (").concat(kb, ")"));
  }
}

var decoration = {
  general: ModelDecorationOptions.register({
    stickiness: 1
    /* NeverGrowsWhenTypingAtEdges */
    ,
    collapseOnReplaceEdit: true,
    inlineClassName: 'detected-link'
  }),
  active: ModelDecorationOptions.register({
    stickiness: 1
    /* NeverGrowsWhenTypingAtEdges */
    ,
    collapseOnReplaceEdit: true,
    inlineClassName: 'detected-link-active'
  })
};

var LinkOccurrence = /*#__PURE__*/function () {
  function LinkOccurrence(link, decorationId) {
    _classCallCheck(this, LinkOccurrence);

    this.link = link;
    this.decorationId = decorationId;
  }

  _createClass(LinkOccurrence, [{
    key: "activate",
    value: function activate(changeAccessor, useMetaKey) {
      changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, true));
    }
  }, {
    key: "deactivate",
    value: function deactivate(changeAccessor, useMetaKey) {
      changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, false));
    }
  }], [{
    key: "decoration",
    value: function decoration(link, useMetaKey) {
      return {
        range: link.range,
        options: LinkOccurrence._getOptions(link, useMetaKey, false)
      };
    }
  }, {
    key: "_getOptions",
    value: function _getOptions(link, useMetaKey, isActive) {
      var options = Object.assign({}, isActive ? decoration.active : decoration.general);
      options.hoverMessage = getHoverMessage(link, useMetaKey);
      return options;
    }
  }]);

  return LinkOccurrence;
}();

var LinkDetector = /*#__PURE__*/function () {
  function LinkDetector(editor, openerService, notificationService) {
    var _this = this;

    _classCallCheck(this, LinkDetector);

    this.listenersToRemove = new DisposableStore();
    this.editor = editor;
    this.openerService = openerService;
    this.notificationService = notificationService;
    var clickLinkGesture = new ClickLinkGesture(editor);
    this.listenersToRemove.add(clickLinkGesture);
    this.listenersToRemove.add(clickLinkGesture.onMouseMoveOrRelevantKeyDown(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          mouseEvent = _ref2[0],
          keyboardEvent = _ref2[1];

      _this._onEditorMouseMove(mouseEvent, keyboardEvent);
    }));
    this.listenersToRemove.add(clickLinkGesture.onExecute(function (e) {
      _this.onEditorMouseUp(e);
    }));
    this.listenersToRemove.add(clickLinkGesture.onCancel(function (e) {
      _this.cleanUpActiveLinkDecoration();
    }));
    this.enabled = editor.getOption(54
    /* links */
    );
    this.listenersToRemove.add(editor.onDidChangeConfiguration(function (e) {
      var enabled = editor.getOption(54
      /* links */
      );

      if (_this.enabled === enabled) {
        // No change in our configuration option
        return;
      }

      _this.enabled = enabled; // Remove any links (for the getting disabled case)

      _this.updateDecorations([]); // Stop any computation (for the getting disabled case)


      _this.stop(); // Start computing (for the getting enabled case)


      _this.beginCompute();
    }));
    this.listenersToRemove.add(editor.onDidChangeModelContent(function (e) {
      return _this.onChange();
    }));
    this.listenersToRemove.add(editor.onDidChangeModel(function (e) {
      return _this.onModelChanged();
    }));
    this.listenersToRemove.add(editor.onDidChangeModelLanguage(function (e) {
      return _this.onModelModeChanged();
    }));
    this.listenersToRemove.add(LinkProviderRegistry.onDidChange(function (e) {
      return _this.onModelModeChanged();
    }));
    this.timeout = new async.TimeoutTimer();
    this.computePromise = null;
    this.activeLinksList = null;
    this.currentOccurrences = {};
    this.activeLinkDecorationId = null;
    this.beginCompute();
  }

  _createClass(LinkDetector, [{
    key: "onModelChanged",
    value: function onModelChanged() {
      this.currentOccurrences = {};
      this.activeLinkDecorationId = null;
      this.stop();
      this.beginCompute();
    }
  }, {
    key: "onModelModeChanged",
    value: function onModelModeChanged() {
      this.stop();
      this.beginCompute();
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var _this2 = this;

      this.timeout.setIfNotSet(function () {
        return _this2.beginCompute();
      }, LinkDetector.RECOMPUTE_TIME);
    }
  }, {
    key: "beginCompute",
    value: function beginCompute() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var model;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.editor.hasModel() || !this.enabled)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                model = this.editor.getModel();

                if (LinkProviderRegistry.has(model)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (this.activeLinksList) {
                  this.activeLinksList.dispose();
                  this.activeLinksList = null;
                }

                this.computePromise = async.createCancelablePromise(function (token) {
                  return getLinks(model, token);
                });
                _context.prev = 7;
                _context.next = 10;
                return this.computePromise;

              case 10:
                this.activeLinksList = _context.sent;
                this.updateDecorations(this.activeLinksList.links);
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                onUnexpectedError(_context.t0);

              case 17:
                _context.prev = 17;
                this.computePromise = null;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 14, 17, 20]]);
      }));
    }
  }, {
    key: "updateDecorations",
    value: function updateDecorations(links) {
      var useMetaKey = this.editor.getOption(61
      /* multiCursorModifier */
      ) === 'altKey';
      var oldDecorations = [];
      var keys = Object.keys(this.currentOccurrences);

      for (var i = 0, len = keys.length; i < len; i++) {
        var decorationId = keys[i];
        var occurance = this.currentOccurrences[decorationId];
        oldDecorations.push(occurance.decorationId);
      }

      var newDecorations = [];

      if (links) {
        // Not sure why this is sometimes null
        var _iterator = _createForOfIteratorHelper(links),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var link = _step.value;
            newDecorations.push(LinkOccurrence.decoration(link, useMetaKey));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var decorations = this.editor.deltaDecorations(oldDecorations, newDecorations);
      this.currentOccurrences = {};
      this.activeLinkDecorationId = null;

      for (var _i = 0, _len = decorations.length; _i < _len; _i++) {
        var _occurance = new LinkOccurrence(links[_i], decorations[_i]);

        this.currentOccurrences[_occurance.decorationId] = _occurance;
      }
    }
  }, {
    key: "_onEditorMouseMove",
    value: function _onEditorMouseMove(mouseEvent, withKey) {
      var _this3 = this;

      var useMetaKey = this.editor.getOption(61
      /* multiCursorModifier */
      ) === 'altKey';

      if (this.isEnabled(mouseEvent, withKey)) {
        this.cleanUpActiveLinkDecoration(); // always remove previous link decoration as their can only be one

        var occurrence = this.getLinkOccurrence(mouseEvent.target.position);

        if (occurrence) {
          this.editor.changeDecorations(function (changeAccessor) {
            occurrence.activate(changeAccessor, useMetaKey);
            _this3.activeLinkDecorationId = occurrence.decorationId;
          });
        }
      } else {
        this.cleanUpActiveLinkDecoration();
      }
    }
  }, {
    key: "cleanUpActiveLinkDecoration",
    value: function cleanUpActiveLinkDecoration() {
      var useMetaKey = this.editor.getOption(61
      /* multiCursorModifier */
      ) === 'altKey';

      if (this.activeLinkDecorationId) {
        var occurrence = this.currentOccurrences[this.activeLinkDecorationId];

        if (occurrence) {
          this.editor.changeDecorations(function (changeAccessor) {
            occurrence.deactivate(changeAccessor, useMetaKey);
          });
        }

        this.activeLinkDecorationId = null;
      }
    }
  }, {
    key: "onEditorMouseUp",
    value: function onEditorMouseUp(mouseEvent) {
      if (!this.isEnabled(mouseEvent)) {
        return;
      }

      var occurrence = this.getLinkOccurrence(mouseEvent.target.position);

      if (!occurrence) {
        return;
      }

      this.openLinkOccurrence(occurrence, mouseEvent.hasSideBySideModifier, true
      /* from user gesture */
      );
    }
  }, {
    key: "openLinkOccurrence",
    value: function openLinkOccurrence(occurrence, openToSide) {
      var _this4 = this;

      var fromUserGesture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!this.openerService) {
        return;
      }

      var link = occurrence.link;
      link.resolve(CancellationToken.None).then(function (uri) {
        // Support for relative file URIs of the shape file://./relativeFile.txt or file:///./relativeFile.txt
        if (typeof uri === 'string' && _this4.editor.hasModel()) {
          var modelUri = _this4.editor.getModel().uri;

          if (modelUri.scheme === Schemas.file && strings.startsWith(uri, 'file:')) {
            var parsedUri = URI.parse(uri);

            if (parsedUri.scheme === Schemas.file) {
              var fsPath = resources.originalFSPath(parsedUri);
              var relativePath = null;

              if (strings.startsWith(fsPath, '/./')) {
                relativePath = ".".concat(fsPath.substr(1));
              } else if (strings.startsWith(fsPath, '//./')) {
                relativePath = ".".concat(fsPath.substr(2));
              }

              if (relativePath) {
                uri = resources.joinPath(modelUri, relativePath);
              }
            }
          }
        }

        return _this4.openerService.open(uri, {
          openToSide: openToSide,
          fromUserGesture: fromUserGesture
        });
      }, function (err) {
        var messageOrError = err instanceof Error ? err.message : err; // different error cases

        if (messageOrError === 'invalid') {
          _this4.notificationService.warn(nls.localize('invalid.url', 'Failed to open this link because it is not well-formed: {0}', link.url.toString()));
        } else if (messageOrError === 'missing') {
          _this4.notificationService.warn(nls.localize('missing.url', 'Failed to open this link because its target is missing.'));
        } else {
          onUnexpectedError(err);
        }
      });
    }
  }, {
    key: "getLinkOccurrence",
    value: function getLinkOccurrence(position) {
      if (!this.editor.hasModel() || !position) {
        return null;
      }

      var decorations = this.editor.getModel().getDecorationsInRange({
        startLineNumber: position.lineNumber,
        startColumn: position.column,
        endLineNumber: position.lineNumber,
        endColumn: position.column
      }, 0, true);

      var _iterator2 = _createForOfIteratorHelper(decorations),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _decoration = _step2.value;
          var currentOccurrence = this.currentOccurrences[_decoration.id];

          if (currentOccurrence) {
            return currentOccurrence;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(mouseEvent, withKey) {
      return Boolean(mouseEvent.target.type === 6
      /* CONTENT_TEXT */
      && (mouseEvent.hasTriggerModifier || withKey && withKey.keyCodeIsTriggerKey));
    }
  }, {
    key: "stop",
    value: function stop() {
      this.timeout.cancel();

      if (this.activeLinksList) {
        this.activeLinksList.dispose();
      }

      if (this.computePromise) {
        this.computePromise.cancel();
        this.computePromise = null;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.listenersToRemove.dispose();
      this.stop();
      this.timeout.dispose();
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(LinkDetector.ID);
    }
  }]);

  return LinkDetector;
}();

LinkDetector.ID = 'editor.linkDetector';
LinkDetector.RECOMPUTE_TIME = 1000; // ms

LinkDetector = __decorate([__param(1, IOpenerService), __param(2, INotificationService)], LinkDetector);
export { LinkDetector };

var OpenLinkAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(OpenLinkAction, _EditorAction);

  var _super = _createSuper(OpenLinkAction);

  function OpenLinkAction() {
    _classCallCheck(this, OpenLinkAction);

    return _super.call(this, {
      id: 'editor.action.openLink',
      label: nls.localize('label', "Open Link"),
      alias: 'Open Link',
      precondition: undefined
    });
  }

  _createClass(OpenLinkAction, [{
    key: "run",
    value: function run(accessor, editor) {
      var linkDetector = LinkDetector.get(editor);

      if (!linkDetector) {
        return;
      }

      if (!editor.hasModel()) {
        return;
      }

      var selections = editor.getSelections();

      var _iterator3 = _createForOfIteratorHelper(selections),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var sel = _step3.value;
          var link = linkDetector.getLinkOccurrence(sel.getEndPosition());

          if (link) {
            linkDetector.openLinkOccurrence(link, false);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return OpenLinkAction;
}(EditorAction);

registerEditorContribution(LinkDetector.ID, LinkDetector);
registerEditorAction(OpenLinkAction);
registerThemingParticipant(function (theme, collector) {
  var activeLinkForeground = theme.getColor(editorActiveLinkForeground);

  if (activeLinkForeground) {
    collector.addRule(".monaco-editor .detected-link-active { color: ".concat(activeLinkForeground, " !important; }"));
  }
});